{
  "en": {
    "hangarPlanner": {
      "title": "Hangar Planner",
      "lead": "Plan the hangar you want in slots — the roles you want covered — and work out how to get there from the hangar you have: what to keep, what to melt and which upgrades and buy-backs to use.",
      "createPlan": "New plan",
      "editPlan": "Edit plan",
      "destroyPlan": "Delete plan",
      "confirmDestroy": "Delete this plan? Your hangar is not affected.",
      "share": "Share by link",
      "copyShareLink": "Copy share link",
      "unshare": "Stop sharing",
      "shared": "Shared",
      "sharedMissing": "This plan is not shared, or the link has changed.",
      "addToWishlist": "Add purchases to wishlist",
      "confirmAddToWishlist": "Add every ship this plan still has to obtain to your wishlist?",
      "compareWith": "Compare with %{plan}",
      "compareTitle": "%{left} vs. %{right}",
      "slotsCount": {
        "one": "%{count} slot",
        "other": "%{count} slots"
      },
      "updatedAt": "Updated %{date}",
      "empty": {
        "title": "No plans yet",
        "text": "Start a plan from scratch, from your hangar, from your wishlist or by copying another plan."
      },
      "noSlots": "This plan has no slots yet. Add a slot for each role you want your hangar to cover.",
      "placeholderRoles": {
        "starter": "Daily driver",
        "cargo": "Cargo hauler",
        "exploration": "Explorer"
      },
      "useAsFirstSlot": "Make this my first slot",
      "addSlot": "Add slot",
      "editSlot": "Edit slot",
      "editSlotOf": "Edit %{slot}",
      "slotSettings": "Name and filters",
      "removeSlot": "Remove slot",
      "confirmRemoveSlot": "Remove this slot together with its ships and routes?",
      "openSlotHint": "No ship picked yet. Add one ship, or several if you are undecided.",
      "addShips": "Add ships",
      "addCandidates": "Ships for %{slot}",
      "addToSlot": "Add to slot",
      "inSlot": "In this slot",
      "choose": "Choose",
      "chooseHint": "Pick the ship this slot plans for. The other ships leave the slot, together with any routes to them.",
      "removeCandidate": "Remove ship",
      "ownedCount": {
        "one": "%{count} in your hangar",
        "other": "%{count} in your hangar"
      },
      "notOnSale": "not on sale",
      "routes": "How you get them",
      "editRoute": "Route to %{ship}",
      "removeRoute": "Remove route",
      "unresolvedUnits": {
        "one": "%{count} ship has no route yet",
        "other": "%{count} ships have no route yet"
      },
      "routeMustEnd": "The route has to end on the %{ship}.",
      "upgradeSteps": "Upgrades",
      "stepNumber": "Upgrade %{number}",
      "addStep": "Add upgrade",
      "removeStep": "Remove upgrade",
      "sourceMissing": "no longer in your hangar",
      "melts": "Melts",
      "noMelts": "No ships to melt.",
      "addMelt": "Melt a ship",
      "editMelt": "Edit melt",
      "removeMelt": "Keep the ship",
      "estimated": "estimate",
      "free": "Free",
      "unknownPrice": "Unknown",
      "fields": {
        "name": "Name",
        "description": "Description",
        "startingCredit": "Store credit",
        "startingCreditInfo": "Store credit you already have, in USD.",
        "source": "Start from",
        "sourcePlan": "Plan to copy",
        "slotLabel": "Role",
        "slotLabelPlaceholder": "e.g. Main hauler",
        "quantity": "Ships",
        "startKind": "Starts as",
        "ownedShip": "Ship from your hangar",
        "buyback": "Buy-back pledge",
        "priceOverride": "Price paid",
        "priceOverrideInfo": "Leave empty to use today's store price, or enter a sale or warbond price.",
        "upgradeSource": "Upgrade from",
        "ownedUpgrade": "Upgrade in your RSI hangar",
        "upgradeTo": "Upgrade to",
        "meltShip": "Ship to melt",
        "meltValue": "Credit",
        "meltValueInfo": "What melting gives. Leave empty to use what RSI lists the pledge at, or today's store price where the hangar sync has not read it.",
        "slotDescription": "Description",
        "filters": "Ships that fit",
        "filtersInfo": "The ship picker opens on these filters. Ships outside them can still be added, and are marked.",
        "priceFrom": "Price from",
        "priceTo": "Price up to",
        "minCargo": "Cargo at least",
        "onSaleOnly": "Only ships on sale",
        "buybackTokens": "Buy-back tokens",
        "buybackTokensInfo": "Each token lets you pay for one buy-back with store credit. Without one, a buy-back costs new money.",
        "buybackTokensSynced": "Each token lets you pay for one buy-back with store credit. Your last buy-back sync read %{count} from RSI; leave this empty to use that.",
        "vatRate": "VAT",
        "vatRateInfo": "The VAT RSI adds at checkout where you live, e.g. 19 in Germany. It applies to new money only; store credit already includes it."
      },
      "sources": {
        "empty": "An empty plan",
        "hangar": "My hangar",
        "wishlist": "My wishlist",
        "plan": "Another plan"
      },
      "states": {
        "open": "Open",
        "decided": "Decided",
        "undecided": "Undecided"
      },
      "startKinds": {
        "owned": "Kept from hangar",
        "store": "Store purchase",
        "ingame": "Bought in game",
        "buyback": "Buy-back"
      },
      "upgradeSources": {
        "store": "Store",
        "owned_ccu": "My RSI hangar",
        "buyback": "Buy-back"
      },
      "vehicleStatuses": {
        "kept": "Kept",
        "upgraded": "Upgraded",
        "unrouted": "Route missing",
        "melted": "Melted",
        "pending": "Needs a decision",
        "change": "Should change",
        "unassigned": "Not in plan"
      },
      "changes": {
        "added": "New",
        "removed": "Gone",
        "more": "More",
        "fewer": "Fewer",
        "unchanged": "Same"
      },
      "issues": {
        "missing_price": "%{name} has no known price, so the total leaves it out.",
        "not_on_sale": "%{name} is not on sale right now."
      },
      "summary": {
        "title": "Costs",
        "spend": "New spend",
        "routedSpend": "Spend with routes",
        "maxSpend": "Most it can come to",
        "upTo": "up to %{value}",
        "meltCredit": "Credit from melts",
        "startingCredit": "Store credit",
        "net": "Net cost",
        "cashNeeded": "Still to pay",
        "remainingCredit": "Credit left",
        "estimatedMelts": {
          "one": "%{count} estimated",
          "other": "%{count} estimated"
        },
        "openSlots": {
          "one": "%{count} slot without a ship",
          "other": "%{count} slots without a ship"
        },
        "undecidedSlots": {
          "one": "%{count} undecided slot",
          "other": "%{count} undecided slots"
        },
        "unresolved": {
          "one": "%{count} ship without a route",
          "other": "%{count} ships without a route"
        },
        "incomplete": "The total is incomplete",
        "complete": "Every ship has a route and a price.",
        "buybackCash": "Buy-backs in new money",
        "buybacksWithoutToken": {
          "one": "%{count} buy-back without a token",
          "other": "%{count} buy-backs without a token"
        },
        "tokensShort": {
          "one": "%{count} buy-back uses a token, but you have %{available}. The rest is counted as new money.",
          "other": "%{count} buy-backs use a token, but you have %{available}. The rest is counted as new money."
        }
      },
      "comparison": {
        "title": "Compared with your hangar",
        "yourShips": "Your ships",
        "noShips": "Your hangar has no ships.",
        "changes": "Changes",
        "noChanges": "No changes.",
        "toAcquire": "Still to obtain",
        "hangar": "Hangar",
        "plan": "Plan",
        "happens": "What happens",
        "meltCredit": "%{value} credit",
        "leaves": "Leaves your hangar",
        "lead": "Every ship you own on the left, every ship the plan needs on the right, and what happens in between.",
        "anotherPlan": "Compare with another plan",
        "tallies": {
          "pending": {
            "one": "%{count} to decide",
            "other": "%{count} to decide"
          },
          "change": {
            "one": "%{count} to change",
            "other": "%{count} to change"
          },
          "kept": {
            "one": "%{count} kept",
            "other": "%{count} kept"
          },
          "upgraded": {
            "one": "%{count} upgraded",
            "other": "%{count} upgraded"
          },
          "unrouted": {
            "one": "%{count} without a route",
            "other": "%{count} without a route"
          },
          "melted": {
            "one": "%{count} melted",
            "other": "%{count} melted"
          },
          "toAcquire": {
            "one": "%{count} still to obtain",
            "other": "%{count} still to obtain"
          },
          "open": {
            "one": "%{count} open slot",
            "other": "%{count} open slots"
          }
        },
        "costsTitle": "What it costs",
        "flow": {
          "steps": {
            "one": "%{count} upgrade · %{price}",
            "other": "%{count} upgrades · %{price}"
          },
          "shipOf": "ship %{number} of %{count}",
          "noRoute": "No route yet",
          "planRoute": "Plan route",
          "noUpgrade": "No upgrade possible",
          "pickOtherStart": "pick another start",
          "notCounted": "not in the total",
          "onlyInMax": "only in the maximum",
          "noShip": "no ship yet",
          "folded": {
            "kept": {
              "one": "%{count} kept as it is",
              "other": "%{count} kept as they are"
            },
            "melted": {
              "one": "%{count} melted",
              "other": "%{count} melted"
            },
            "unassigned": {
              "one": "%{count} ship not in the plan",
              "other": "%{count} ships not in the plan"
            }
          }
        },
        "changeSides": {
          "in": "Comes in",
          "out": "Goes out"
        },
        "unchangedCount": {
          "one": "%{count} model stays as it is.",
          "other": "%{count} models stay as they are."
        },
        "after": "After the plan"
      },
      "metrics": {
        "title": "Stats",
        "total": "Ships",
        "uniqueModelsCount": "Different models",
        "manufacturerCount": "Manufacturers",
        "flightReadyCount": "Flight ready",
        "totalCrew": "Crew",
        "totalCargo": "Cargo (SCU)",
        "totalPledgeValue": "Store value",
        "largestShip": "Largest ship",
        "smallestShip": "Smallest ship",
        "classifications": "Classifications",
        "sizes": "Sizes",
        "productionStatuses": "Production status"
      },
      "drift": {
        "title": "Your hangar changed since this plan was made",
        "missing": {
          "one": "%{count} ship or pledge the plan uses is gone.",
          "other": "%{count} ships or pledges the plan uses are gone."
        },
        "changed": {
          "one": "%{count} ship is now another model.",
          "other": "%{count} ships are now other models."
        },
        "added": "New in your hangar: %{ships}",
        "prices": "Prices changed: %{before} when planned, %{now} today.",
        "rebase": "Update from hangar"
      },
      "messages": {
        "saved": "Plan saved.",
        "saveFailed": "That did not work. Please check your input.",
        "shareCopied": "Share link copied.",
        "unshared": "The share link no longer works.",
        "addedToWishlist": {
          "one": "%{count} ship added to your wishlist.",
          "other": "%{count} ships added to your wishlist."
        },
        "rebased": "Plan updated from your hangar.",
        "sharingOn": "Sharing is on. Anyone with the link can view this plan.",
        "copyFailed": "The link could not be copied. Copy it from the field instead.",
        "filtersSaved": "Filters saved for %{slot}"
      },
      "filterChips": {
        "priceFrom": "from %{price}",
        "priceTo": "up to %{price}",
        "cargo": "%{cargo} SCU or more",
        "onSale": "on sale"
      },
      "outsideFilters": "outside this slot's filters",
      "shareLink": "Share link",
      "specs": {
        "price": "Price",
        "cargo": "Cargo",
        "crew": "Crew",
        "size": "Size",
        "best": "best"
      },
      "readiness": {
        "routed": {
          "one": "%{routed} of %{count} ship has a route",
          "other": "%{routed} of %{count} ships have a route"
        },
        "undecided": "%{slot} is undecided",
        "open": "%{slot} has no ship",
        "unresolved": {
          "one": "%{slot}: %{count} ship without a route",
          "other": "%{slot}: %{count} ships without a route"
        }
      },
      "meta": {
        "undecided": "%{count} undecided",
        "open": "%{count} open"
      },
      "route": {
        "stillToReach": "Still to reach",
        "yourRoute": "Your route",
        "done": "The route ends on the %{ship}.",
        "isTarget": "Same ship",
        "search": "Search",
        "noMatch": "Nothing matches.",
        "reaches": "Reaches the %{ship}",
        "left": {
          "one": "%{count} left",
          "other": "%{count} left"
        },
        "showAll": {
          "one": "Show your %{count} upgrade",
          "other": "Show all %{count} upgrades"
        },
        "showFitting": "Show only the upgrades that fit",
        "unknownTarget": "Which ship it upgrades to",
        "startCost": "Start",
        "sort": {
          "price": "Price",
          "name": "Name"
        },
        "change": "Change",
        "from": "From",
        "to": "To",
        "todaysPrice": "Today's price: %{price}",
        "noStoreShip": "No store ship fits here.",
        "paidWithCredit": "Store credit",
        "paidWithCash": "New money",
        "vat": "VAT (%{rate}%)",
        "cashWithVat": "New money with VAT",
        "paymentHint": "Store credit covers the store and buy-backs with a token. A buy-back without a token takes new money, as does anything your credit does not cover.",
        "ownedPaid": "Already paid",
        "noHeld": {
          "owned_ccu": "None of the upgrades in your RSI hangar start from the %{ship}.",
          "buyback": "None of your buy-back upgrades start from the %{ship}."
        },
        "shipCard": "Ship",
        "useToken": "Use buy-back token",
        "withToken": "paid with a token"
      },
      "meltList": {
        "none": "None of your ships can be melted, as far as RSI says. Turn off the filter to pick any ship.",
        "credit": "%{value} credit",
        "estimate": "%{value} estimate",
        "wholePledge": {
          "one": "melts %{count} item",
          "other": "melts the whole pledge: %{count} items"
        },
        "meltableOnly": "Meltable only",
        "notMeltable": "not meltable",
        "notSynced": "not synced",
        "noShips": "None of your ships is free to melt.",
        "inPackage": "in %{name}",
        "contents": "Melts with it",
        "contentsOf": "Melts with it, as part of %{name}",
        "unlisted": {
          "one": "%{count} more item the hangar sync does not list",
          "other": "%{count} more items the hangar sync does not list"
        }
      },
      "decisions": {
        "keep": "Keep as it is",
        "melt": "Melt",
        "change": "Mark as should change",
        "pending": "Back to undecided",
        "upgradeTo": "Upgrade %{name} to",
        "keepPending": "Keep all undecided"
      },
      "pick": {
        "pickStart": "Pick a start",
        "pickEnd": "Pick where it ends up",
        "startOf": "Pick the start for %{ship}",
        "endOf": "Pick where %{ship} ends up",
        "startTitle": "Start for %{ship}",
        "startEyebrow": "Start ship",
        "endTitle": "Where %{ship} ends up",
        "endEyebrow": "End ship",
        "buyNew": "Buy new on the store",
        "current": "Current start",
        "use": "Use",
        "noShips": "No hangar ship is free for this slot.",
        "removeStart": "Remove from the slot",
        "same": "Same ship, kept as it is",
        "sameModel": "Same model",
        "noEnds": "No ship this one can become.",
        "removeEnd": "Take out of the plan",
        "anyShip": "Any ship",
        "buyChosen": "The ship you pick next",
        "onlyMelt": "No upgrades exist for it, so it can only be melted",
        "excludes": "Rules out %{ships}",
        "ccuSalesOnly": "CCU only during sales",
        "ccuUnknown": "No CCU seen yet",
        "sources": {
          "hangar": "Your hangar",
          "buyback": "Buy-back",
          "store": "Store"
        },
        "filters": "Narrow the starts",
        "saveFilters": "Save filters for this slot",
        "chooseShip": "Choose a ship",
        "earnInGame": "Earn in game",
        "newSlot": "New slot",
        "endSources": {
          "plan": "Slots in the plan",
          "catalogue": "Any ship"
        }
      },
      "slotsTitle": "Slots",
      "editSlots": "Edit slots",
      "slotNumber": "Slot %{number}",
      "suggestions": {
        "title": "Suggestions",
        "lead": "Ideas for the hangar this plan ends with, once every ship it melts or upgrades away is gone.",
        "redundant": "Redundant ships",
        "noRedundant": "No ship does the same job twice.",
        "duplicate": "%{ship} × %{count}",
        "hints": {
          "duplicate": "The same ship more than once. Melting an extra one gives store credit back.",
          "role": "%{count} ships of the same role. One of them may be enough."
        },
        "inSlot": "Slot %{slot}",
        "inHangar": "Your hangar"
      }
    }
  }
}
